import './tooltip.less';

import classNames from 'classnames';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Tipsy from 'zoomforth_component_lib/tipsy.jsx';
import { TooltipIcon } from 'zoomforth_component_lib/app_modern_icons.jsx';

class Tooltip extends Component {

  render() {
    let { placement } = this.props;
    const { className, gravity, value, style, mouseEnterDelay } = this.props;

    if (!placement) {
      placement = {
        n: 'top',
        e: 'left',
        s: 'bottom',
        w: 'right' 

      }[gravity];
    }

    return (
      <Tipsy content={value} placement={placement} mouseEnterDelay={mouseEnterDelay}>
        <TooltipIcon className={classNames(className, 'zf-tooltip-container')} style={style} />
      </Tipsy>
    );
  }
}

Tooltip.propTypes = {
  value: PropTypes.node,
  gravity: PropTypes.string,
  placement: PropTypes.string
};

Tooltip.defaultProps = {
  placement: 'bottom',
  // Tooltip icons only purpose is to display a tipsy, so they should
  // appear faster than a normal tipsy
  mouseEnterDelay: 0.3 
};


export default Tooltip;
